import { SESSION_KEYS, sessionStorage } from "@/types/session-storage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/registrant/inspections")({
  beforeLoad: () => {
    sessionStorage.set(
      SESSION_KEYS.REGISTRANT_DASHBOARD_SELECTED_TAB,
      "inspections",
    );
    throw redirect({ to: "/registrant/dashboard" });
  },
  component: () => null,
});
